import { render, staticRenderFns } from "./add-to-cart-parent.vue?vue&type=template&id=fb4f66d2"
import script from "./add-to-cart-parent.vue?vue&type=script&lang=js"
export * from "./add-to-cart-parent.vue?vue&type=script&lang=js"
import style0 from "./add-to-cart-parent.vue?vue&type=style&index=0&id=fb4f66d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports